import React from 'react';
import Card from '@mui/material/Card';
import { IdioticCardHeader } from './IdioticCardHeader';
import { IdioticCardFooter } from './IdioticCardFooter';
import { IdioticCardBody } from './IdioticCardBody';
import { slugify } from '../../utils/slugify';
import { track } from '../../utils/track';
import { punchline } from '../../utils/myths';

// Optional number bars a card can carry (cardDetails.bars), drawn between the
// headline and the receipts: [{ label, value, pct, tone: 'good' | 'bad' | '' }].
export const NumberBars = ({ caption, bars }) => (
  <div className="fi-vbars" role="img" aria-label={`${caption}: ${bars.map((b) => `${b.label} ${b.value}`).join(', ')}`}>
    <span className="fi-vcap">{caption}</span>
    {bars.map((b) => (
      <div key={b.label} className={`fi-vb${b.tone ? ` fi-vb--${b.tone}` : ''}`} aria-hidden="true">
        <span>{b.label}</span>
        <i style={{ width: `${b.pct}%` }} />
        <b>{b.value}</b>
      </div>
    ))}
  </div>
);

export const IdioticStatementCard = ({ cardDetails, onUnpop }) => {
  const { id, title, titleBadge, truthSnippet, truth, idiotTypes, categories, sources, bars, barsCaption } = cardDetails;
  const [expanded, setExpanded] = React.useState(false);
  const handleExpandClick = () => {
    track('myth_expand', { title, open: !expanded });
    setExpanded(!expanded);
  };

  // If the user arrived via a deep link (?s=slug) that targets this card,
  // auto-expand it so the debunk is visible without an extra click.
  React.useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      const targetSlug = params.get('s');
      if (!targetSlug) return;
      // slugify both sides so old links (apostrophes/commas intact) still match.
      if (slugify(targetSlug) === slugify(title)) {
        setExpanded(true);
      }
    } catch (_) {
      // no-op
    }
  }, [title]);

  const relatedChips = [
    ...idiotTypes.map((idiot) => ({ cat: 'idiotType', val: idiot })),
    ...categories.map((category) => ({ cat: 'categories', val: category })),
  ];

  const number = id ? String(id).padStart(2, '0') : '';

  return (
    <Card className="card fi-mcard">
      <IdioticCardHeader idioticCardHeaderProps={{ title, titleBadge, handleExpandClick, expanded, number }} />
      {Array.isArray(bars) && bars.length > 0 && (
        <div className="fi-mc-bars"><NumberBars caption={barsCaption || 'The numbers'} bars={bars} /></div>
      )}
      <IdioticCardBody idioticCardBodyProps={{ title, titleBadge, answer: punchline(cardDetails), truthSnippet, truth, relatedChips, sources, expanded, idiotTypes, categories }} />
      <IdioticCardFooter idioticCardFooterProps={{ title, expanded, handleExpandClick, idiotTypes, onUnpop }} />
    </Card>
  );
};
